import { Component } from '@angular/core';
//import { SignalRService } from '../services/signalr.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  public alertMessageClass = "";
  public showAlertMessage = false;

  // constructor(private signalRService: SignalRService) { }

  ngOnInit() {
    // this.signalRService.startConnection("notificationshub");
    // this.signalRService.addNotificationListener();   
  }
}
